module.exports = __webpack_public_path__ + "img/nova-vue.f444f365.png";